//#region Filters

$(document).on(gridEvents.AFTER_RENDER, '.kdr-filters', function () {
    let $filter = $(this)
    controls.filters.initUI($filter)

    let $tilemenuWrapper = $filter.closest('.modern-tile-menu-row')

    tilemenu.generateDisplayValues($tilemenuWrapper)
})


$(document).on("click", ".kdr-filters-filter:not(.ignore)", function () {
    let that = $(this)
    let $filters = that.closest(".kdr-filters")
    //let inputs = filters.find(".kdr-filters-input")
    let inputs = controls.getInputs($filters)
    let control = $("#" + $filters.attr("data-control-id"))

    let $loadingIndicator = control.closest('.modal-content').length != 0 ? control.closest('.modal-content') : control

    let args = {} 
    controls.getArgs(inputs, args)


    $.ajax({
        type: "POST",
        url: __root + "Filters/Change",
        datatype: "json",
        traditional: true,
        data: {
            "info": controls.getInfo($filters),// $filters.find(".kdr-info").val(),
            "args": JSON.stringify(args)
        },
        success: function (response) {
            controls.magic("Filters/Render", $filters, response, control)

            $.ajax({
                type: "POST",
                url: __root + "Filters/Filter",
                datatype: "json",
                traditional: true,
                data: {
                    "control": controls.getInfo(control),// control.find(".kdr-info").val(),
                    "filters": controls.getInfo($filters),// $filters.find(".kdr-info").val(),
                    "args": JSON.stringify(args)
                },
                success: function (response) {
                    controls.magic("Grid/Render", control, response, $loadingIndicator)
                },
                beforeSend: function () {
                    loading.show($loadingIndicator)
                },
                complete: function () {
                    loading.hide(control)
                }
            })
        },
        beforeSend: function () {
            loading.show($loadingIndicator)
        },
        complete: function () {
            loading.hide($loadingIndicator)
        }
    })
})

$(document).on('click', '.kdr-filters-clear:not(.ignore)', function () {
    let $this = $(this)

    controls.clear($this)
})

$(document).on("click", ".kdr-filters-new-order-filter:not(.ignore)", function () {
    let $that = $(this)

    controls.filter($that)
})

$(document).on("change", ".kdr-filters:not(.ignore) .kdr-filters-change.auto-refresh, .kdr-filters:not(.ignore) .kdr-filters-input.auto-refresh", function (e) {
    let $that = $(this)
    let $filters = $that.closest(".kdr-filters")
    //let $inputs = $filters.find(".kdr-filters-input")
    let $inputs = controls.getInputs($filters)

    let args = {}
    controls.getArgs($inputs, args)

    $.ajax({
        type: "POST",
        url: __root + "Filters/Change",
        datatype: "json",
        traditional: true,
        data: {
            "info": controls.getInfo($filters), //$filters.find(".kdr-info").val(),
            "args": JSON.stringify(args)
        },
        success: function (response) {
            let id = $filters.attr("data-control-id")
            let $loadingIndicator = $filters.closest('.modal-content').length > 0 ? $filters.closest('.modal-content') : $filters

            if (id != '') { // filtrowanie po staremu
                controls.magic("Filters/Render", $filters, response)

                args = {}
                controls.getArgs($inputs, args)
                let $control = $("#" + id)

                $.ajax({
                    type: "POST",
                    url: __root + "Filters/Filter",
                    datatype: "json",
                    traditional: true,
                    data: {
                        "control": controls.getInfo($control),//$control.find(".kdr-info").val(),
                        "filters": controls.getInfo($filters),// $filters.find(".kdr-info").val(),
                        "args": JSON.stringify(args)
                    },
                    success: function (response) {
                        controls.magic("Grid/Render", $control, response)
                    },
                    beforeSend: function () {
                        loading.show($loadingIndicator)
                    },
                    complete: function () {
                        loading.hide($loadingIndicator)
                    }
                })

            } else if ('' == id && response.coode != 3) {
                let filtersId = '#' + $filters.prop('id')
                $(document).one(gridEvents.AFTER_RENDER, filtersId, function () {
                    controls.invokeCommands($(this))
                })

                controls.render("Filters/Render", $filters, response.info, $filters)
            }
        },
        beforeSend: () => loading.show($filters),
        complete: () => loading.hide($filters)
    })
})

$(document).on("keyup", ".kdr-filters-input", function (e) {
    if (e.keyCode !== 13) {
        return
    } else {
        let that = $(this)
        let filters = that.closest(".kdr-filters")

        filters.find('.kdr-filters-filter, .kdr-filters-new-order-filter').click()
    }
})

$(document).on('click', '.kdr-filters-tabs-filter-new-order', function () {
    let $that = $(this)

    controls.tabFilter($that)

    var list1 = document.getElementsByClassName("leader-line");
    var temp = list1.length

    if (temp > 0) {
        for (i = 0; i < temp; i++) {
            list1[0].remove();
        }

    }
});

$(document).on("click", ".kdr-filters-tabs-filter", function () {
    let that = $(this)
    let tabs = that.closest(".kdr-filters-tabs")

    let args = {}
    let controlType;
    let magicRelations = [];
    args[tabs.attr("data-index")] = that.attr("data-value")
    if (magic_relations) {
        magicRelations = magic_relations.filter(function (el) {
            if (el.source == tabs[0].id)
                return true;
        });
    }
    if (magic_relations && magicRelations) {
        for (let i = 0; i < magicRelations.length; i++) {
            let el = magicRelations[i];
            let control = $("#" + el.target);
            if (control.hasClass('kdr-grid')) controlType = 'Grid';
            else if (control.hasClass('kdr-frax')) controlType = 'Frax';
            loading.show(control);
            $.ajax({
                type: "POST",
                url: __root + "Filters/Filter",
                datatype: "json",
                traditional: true,
                data: {
                    "control": controls.getInfo(control),// control.find(".kdr-info").val(),
                    "args": JSON.stringify(args)
                },
                success: function (response) {
                    controls.magic(controlType + "/Render", control, response)
                },
                beforeSend: function () {
                    loading.show(tabs)
                },
                complete: function () {
                    loading.hide(tabs)
                }
            })
        }
    }
    else {
        let control = $("#" + tabs.attr("data-control-id"));
        if (control.hasClass('kdr-grid')) controlType = 'Grid';
        else if (control.hasClass('kdr-frax')) controlType = 'Frax';

        $.ajax({
            type: "POST",
            url: __root + "Filters/Filter",
            datatype: "json",
            traditional: true,
            data: {
                "control": controls.getInfo(control),// control.find(".kdr-info").val(),
                "args": JSON.stringify(args)
            },
            success: function (response) {
                controls.magic(controlType + "/Render", control, response)
            },
            beforeSend: function () {
                loading.show(tabs)
            },
            complete: function () {
                loading.hide(tabs, 150)
            }
        })
    }
})

$(document).on("change", ".kdr-filters .kdr-filters-change:not(.auto-refresh)", function () {
    let that = $(this)
    let filters = that.closest(".kdr-filters")
    //let inputs = filters.find(".kdr-filters-input")
    let inputs = controls.getInputs(filters)

    let args = {}
    controls.getArgs(inputs, args)

    $.ajax({
        type: "POST",
        url: __root + "Filters/Change",
        datatype: "json",
        traditional: true,
        data: {
            "info": controls.getInfo(filters),// filters.find(".kdr-info").val(),
            "args": JSON.stringify(args)
        },
        success: function (response) {
            controls.magic("Filters/Render", filters, response)
        },
        beforeSend: function () {
            loading.show(that)
        },
        complete: function () {
            loading.hide(that)
        }
    })
})

$(document).on('click', '.dynamic-filters-add-btn', function () {
    let $this = $(this)
    let dfInfo = controls.getInfo($this.closest('.kdr-dynamic-filters'))
    let fInfo = controls.getInfo($this.closest('.kdr-dynamic-filters').find('.kdr-filters'))
    let $loadingTarget = $this.closest('.kdr-dynamic-filters')

    $.ajax({
        type: "POST",
        url: __root + "DynamicFilters/ExecuteInsert",
        datatype: "json",
        traditional: true,
        data: {
            dynamicFiltersInfo: dfInfo,
            filtersInfo: fInfo
        },
        success: function (response) {
            controls.onControlBeforeRender($this.closest('.kdr-dynamic-filters'), gridResponseCodes.SUCCESS, null);
            controls.magic("DynamicFilters/Render", $this.closest('.kdr-dynamic-filters'), response, $loadingTarget, true);
        },
        beforeSend: function () {

        }
    })
})
//#endregion Filters